
import { LocalStorageKeys } from '@containers/App';
import { PillarNames } from '@interfaces/pillar';
import BasePaginationQuery from '@interfaces/base-pagination-query';
import TicketServiceEhss from './TicketServiceEhss';
import TicketEventServiceLI from './TicketEventServiceLI';

export default class TicketEventRequestsInterceptor {

  private ticketEventServiceEHSS: TicketServiceEhss = new TicketServiceEhss;
  private ticketServiceLI: TicketEventServiceLI = new TicketEventServiceLI;
  private currentPillar: any;

  async exportProcess(idProcess: string, query: BasePaginationQuery, fields?: string[]): Promise<any> {
    this.currentPillar = localStorage.getItem(LocalStorageKeys.PILLAR);

    let res;
    switch (this.currentPillar) {
      case PillarNames.EHSS:
        res = await this.ticketEventServiceEHSS.exportProcess(idProcess, query, fields);
        break;
      case PillarNames.LI:
        res = await this.ticketServiceLI.exportProcess(idProcess, query, fields);
        break;
    }
    return res;
  }

}